import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PdfMultiProjectReportComponent } from './pdf-multi-project-report.component'; 
import { DxDataGridModule, DxProgressBarModule } from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    DxProgressBarModule,
    CurrencyFormatterPipeModule
  ],
  declarations: [
    PdfMultiProjectReportComponent
  ],
  exports: [
    PdfMultiProjectReportComponent
  ]
})
export class PdfMultiProjectReportModule { }
